import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router';
import { Grid,
  Typography,
  DialogContent,
  CircularProgress,
  Divider,
  Dialog, DialogTitle, DialogActions,
  Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import useAPI from 'hooks/api-hooks';
import useMediaQueries from '../hooks/media-query-hooks';
import UserDetailsForm from '../components/forms/common-forms/UserDetailsForm';

const useStyles = makeStyles((_theme) => {
  return {
    titleCta: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    paper: { minWidth: '770px' },
  };
});

const ProfilePage = (props) => {
  const { title } = props;
  const classes = useStyles();

  const { isMd } = useMediaQueries();
  const { t } = useTranslation();
  const { client } = useAPI();

  const [ deleteAccountConfirmOpen, setDeleteAccountConfirmOpen ] = useState(false);

  const history = useHistory();
  const [ loadingDelete, setLoadingDelete ] = useState(false);

  const deleteAccount = () => {
    setLoadingDelete(true);
    client.delete('customers').then(() => {
      history.push('/logout');
    });
  };

  return (
    <>
      <Dialog
        classes={ { paper: classes.paper } }
        onClose={ () => { setDeleteAccountConfirmOpen(false); } }
        open={ deleteAccountConfirmOpen }
      >
        <DialogTitle>{t('areYouSureDeleteAccount')}</DialogTitle>
        <DialogContent>
          <Typography>
            {t('deleteAccountText1')}
          </Typography>
          <Typography>
            {t('deleteAccountText11')}
          </Typography>

          <Typography>
            {t('deleteAccountText12')}
          </Typography>

          <Typography>
            {t('deleteAccountText2')}

            {' '}
            <span style={ { fontWeight: 'bold' } }>
              {'"'}
              {t('confirmDeletion')}
              {'"'}
            </span>
            {'. '}

            {t('deleteAccountButtonText')}
          </Typography>

          <br />

          <Typography>
            {t('deleteAccountText3')}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={ () => { setDeleteAccountConfirmOpen(false); } }
            disabled={ loadingDelete }
          >
            {t('common.cancel')}
          </Button>
          <Button
            onClick={ deleteAccount }
            style={ { color: loadingDelete ? '#CCCCCC' : 'red' } }
            disabled={ loadingDelete }
          >
            { loadingDelete
          && (
            <CircularProgress
              size={ 24 }
              color='secondary'
              style={ { margin: '0 10px' } }
            />
          ) }
            {t('confirmDeletion')}
          </Button>
        </DialogActions>
      </Dialog>
      <Grid container spacing={ isMd ? 4 : 2 } justifyContent='center'>
        <Grid item xs={ 12 }>
          <div
            className={ classes.titleCta }
            style={ { display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' } }
          >

            <Typography variant='h6' color='textPrimary'>
              {title}
            </Typography>

            <div style={ { display: 'flex', gap: '5px', flexWrap: 'wrap' } }>
              <Button
                variant='contained'
                style={ { color: 'white', background: 'red' } }
                onClick={ () => { setDeleteAccountConfirmOpen(true); } }
              >
                {t('deleteAccount')}
              </Button>
            </div>

          </div>
        </Grid>
        <Grid item xs={ 12 }>
          <Divider />
        </Grid>
        <Grid container item xs={ 11 } style={ { backgroundColor: '#fff', borderRadius: 12 } }>
          <Grid item xs={ 12 }>
            <UserDetailsForm />
          </Grid>
        </Grid>
        {/* <Button /> */}
      </Grid>
    </>
  );
};

export default ProfilePage;
